import React from "react";
import vehicleDamageReportStepImg from "../../../../assets/images/keyless-return/vehicle-damage-report-step-img.svg";


export function VehicleDamageReportStep1({t}) {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        textAlign: "center",
        width: "100%",
        gap: "24px",
        padding: "24px 0",
      }}
    >

      <img
        src={vehicleDamageReportStepImg}
        alt="Verificação do estado do veículo"
        className="return-image"
      />

      <p
        style={{
          fontSize: "15px",
          color: "#333",
          lineHeight: "1.4",
          margin: 0,
        }}
      >
        {t("keylessReturnDamageInstruction")}
      </p>
    </div>
  );
}
